import { render } from "./Invite.vue?vue&type=template&id=68db268e&scoped=true"
import script from "./Invite.vue?vue&type=script&lang=js"
export * from "./Invite.vue?vue&type=script&lang=js"

import "./Invite.vue?vue&type=style&index=0&id=68db268e&scoped=true&lang=scss"

import exportComponent from "/builds/swift-dental/my-swift-dental/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68db268e"]])

export default __exports__